export default __webpack_public_path__ + "static/media/1_11.49af7eb2.png";